

import React from 'react';
import { useConnection } from '@/context/ConnectionContext';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';

export function NetworkStatus() {
  const { isBackendAvailable, isChecking, checkConnection } = useConnection();

  if (isBackendAvailable && !isChecking) {
    return null; // Don't show anything when everything is working
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-white rounded-lg shadow-lg border p-3 max-w-xs">
      <div className="flex items-center space-x-2">
        {isChecking ? (
          <RefreshCw className="w-4 h-4 text-blue-500 animate-spin" />
        ) : isBackendAvailable ? (
          <Wifi className="w-4 h-4 text-green-500" />
        ) : (
          <WifiOff className="w-4 h-4 text-red-500" />
        )}
        
        <div className="flex-1">
          <p className="text-sm font-medium">
            {isChecking ? 'Checking connection...' : 'Backend offline'}
          </p>
          {!isChecking && !isBackendAvailable && (
            <p className="text-xs text-gray-500 mt-1">
              Some features may not work properly. The app will use cached data where possible.
            </p>
          )}
        </div>
        
        {!isChecking && !isBackendAvailable && (
          <button
            onClick={checkConnection}
            className="text-blue-500 hover:text-blue-700 text-xs font-medium"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
